// const API_BASE_URL = process.env.NEXT_PUBLIC_API_URL?.replace(/\/+$/, '') || 'http://localhost:8080/api';

// export const fetchHomeMessage = async () => {
//   try {
//     const response = await fetch(`${API_BASE_URL}/home`);
//     return await response.text(); // or .json() if your API returns JSON
//   } catch (error) {
//     console.error("❌ Error in fetchHomeMessage:", error);
//     throw error;
//   }
// };
import axios from 'axios';

let rawBaseUrl = process.env.REACT_APP_API_URL ||
  process.env.NEXT_PUBLIC_API_URL ||
  (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
    ? 'http://localhost:8080/api'
    : 'https://app.papadam-pfullendorf.de/api');

rawBaseUrl = rawBaseUrl.replace(/\/+$/, '');
if (!rawBaseUrl.endsWith('/api')) {
  rawBaseUrl += '/api';
}

const API_BASE_URL = rawBaseUrl;

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// ✅ Request interceptor to attach JWT token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Response interceptor to handle 401 errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('authToken');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// ✅ Example GET request (converted from fetch)
export const fetchHomeMessage = async () => {
  try {
    const response = await apiClient.get('/home');  // ✅ Axios uses `.get()`, not `.fetch()`
    return response.data;
  } catch (error) {
    console.error("❌ Error in fetchHomeMessage:", error);
    throw error;
  }
};


export default apiClient;
